import { FormattedMessage } from "react-intl";
import TeamMembersWrapper from "./TeamMembersWrapper";
import TotalProductsMembersWrapper from "./TotalProductsWrapper";
import TotalReservationWrapper from "./TotalReservationWrapper";
import TotalSalesMembersWrapper from "./TotalSalesWrapper";

const Statistics = ({ data, team_members }: any) => {
  console.log(team_members, "uuuuuuuuuuuuuuuuuu");
  const reservationTrue = () => (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 17.372C0 17.0253 0.281124 16.7441 0.627907 16.7441H15.6977C16.0445 16.7441 16.3256 17.0253 16.3256 17.372C16.3256 17.7188 16.0445 18 15.6977 18H0.627907C0.281124 18 0 17.7188 0 17.372Z"
        fill="#00086D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 6.80716C0 5.99991 0.657868 5.34204 1.46512 5.34204H2.80463C3.61188 5.34204 4.26975 5.99991 4.26975 6.80716V14.0239C4.26975 14.8311 3.61188 15.489 2.80463 15.489H1.46512C0.657868 15.489 0 14.8311 0 14.0239V6.80716ZM1.46512 6.59785C1.35143 6.59785 1.25581 6.69348 1.25581 6.80716V14.0239C1.25581 14.1376 1.35143 14.2332 1.46512 14.2332H2.80463C2.91831 14.2332 3.01393 14.1376 3.01393 14.0239V6.80716C3.01393 6.69348 2.91831 6.59785 2.80463 6.59785H1.46512Z"
        fill="#00086D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.02734 4.13528C6.02734 3.32803 6.68521 2.67017 7.49246 2.67017H8.83197C9.63922 2.67017 10.2971 3.32803 10.2971 4.13528V14.0227C10.2971 14.83 9.63922 15.4878 8.83197 15.4878H7.49246C6.68521 15.4878 6.02734 14.83 6.02734 14.0227V4.13528ZM7.49246 3.92598C7.37878 3.92598 7.28316 4.0216 7.28316 4.13528V14.0227C7.28316 14.1364 7.37878 14.232 7.49246 14.232H8.83197C8.94566 14.232 9.04128 14.1364 9.04128 14.0227V4.13528C9.04128 4.0216 8.94566 3.92598 8.83197 3.92598H7.49246Z"
        fill="#00086D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.0547 1.46512C12.0547 0.657868 12.7126 0 13.5198 0H14.8593C15.6666 0 16.3244 0.657868 16.3244 1.46512V14.0233C16.3244 14.8305 15.6666 15.4884 14.8593 15.4884H13.5198C12.7126 15.4884 12.0547 14.8305 12.0547 14.0233V1.46512ZM13.5198 1.25581C13.4061 1.25581 13.3105 1.35143 13.3105 1.46512V14.0233C13.3105 14.1369 13.4061 14.2326 13.5198 14.2326H14.8593C14.973 14.2326 15.0686 14.1369 15.0686 14.0233V1.46512C15.0686 1.35143 14.973 1.25581 14.8593 1.25581H13.5198Z"
        fill="#00086D"
      />
    </svg>
  );
  const reservationFalse = () => (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 17.372C0 17.0253 0.281124 16.7441 0.627907 16.7441H15.6977C16.0445 16.7441 16.3256 17.0253 16.3256 17.372C16.3256 17.7188 16.0445 18 15.6977 18H0.627907C0.281124 18 0 17.7188 0 17.372Z"
        fill="#9999A7"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 6.80716C0 5.99991 0.657868 5.34204 1.46512 5.34204H2.80463C3.61188 5.34204 4.26975 5.99991 4.26975 6.80716V14.0239C4.26975 14.8311 3.61188 15.489 2.80463 15.489H1.46512C0.657868 15.489 0 14.8311 0 14.0239V6.80716ZM1.46512 6.59785C1.35143 6.59785 1.25581 6.69348 1.25581 6.80716V14.0239C1.25581 14.1376 1.35143 14.2332 1.46512 14.2332H2.80463C2.91831 14.2332 3.01393 14.1376 3.01393 14.0239V6.80716C3.01393 6.69348 2.91831 6.59785 2.80463 6.59785H1.46512Z"
        fill="#9999A7"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.02734 4.13528C6.02734 3.32803 6.68521 2.67017 7.49246 2.67017H8.83197C9.63922 2.67017 10.2971 3.32803 10.2971 4.13528V14.0227C10.2971 14.83 9.63922 15.4878 8.83197 15.4878H7.49246C6.68521 15.4878 6.02734 14.83 6.02734 14.0227V4.13528ZM7.49246 3.92598C7.37878 3.92598 7.28316 4.0216 7.28316 4.13528V14.0227C7.28316 14.1364 7.37878 14.232 7.49246 14.232H8.83197C8.94566 14.232 9.04128 14.1364 9.04128 14.0227V4.13528C9.04128 4.0216 8.94566 3.92598 8.83197 3.92598H7.49246Z"
        fill="#9999A7"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.0547 1.46512C12.0547 0.657868 12.7126 0 13.5198 0H14.8593C15.6666 0 16.3244 0.657868 16.3244 1.46512V14.0233C16.3244 14.8305 15.6666 15.4884 14.8593 15.4884H13.5198C12.7126 15.4884 12.0547 14.8305 12.0547 14.0233V1.46512ZM13.5198 1.25581C13.4061 1.25581 13.3105 1.35143 13.3105 1.46512V14.0233C13.3105 14.1369 13.4061 14.2326 13.5198 14.2326H14.8593C14.973 14.2326 15.0686 14.1369 15.0686 14.0233V1.46512C15.0686 1.35143 14.973 1.25581 14.8593 1.25581H13.5198Z"
        fill="#9999A7"
      />
    </svg>
  );
  const empty =
    data?.appointment_count > 0 ||
    data?.total_product_amount > 0 ||
    data?.total_sales_amount > 0;
  const formatCurrency = (amount: number, locale = "en-US") => {
    const formatter = new Intl.NumberFormat(locale, {
      style: "decimal", // Changed from "currency" to "decimal"
      minimumFractionDigits: 2, // Keeps two decimal places
      maximumFractionDigits: 2, // Ensures consistency in the number of decimals
    });

    return formatter.format(amount);
  };
  console.log(data);

  return (
    <>
      <div className="flex items-center gap-2 mt-4">
        <span>{empty ? reservationTrue() : reservationFalse()}</span>
        <span className={`font-semibold text-lg ${empty || "text-[#75757E]"}`}>
          <FormattedMessage id="statistics" />
        </span>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <TotalSalesMembersWrapper
          sales={formatCurrency(+data?.total_sales_amount)}
          percent={data?.sales_amount_percentage_change}
        />
        <TotalProductsMembersWrapper
          sales={formatCurrency(+data?.total_product_amount)}
          percent={data?.product_amount_percentage_change}
        />
        <TotalReservationWrapper
          appointment_count={data?.appointment_count}
          percent={data?.appointment_percentage_change}
        />
        <TeamMembersWrapper team_members={team_members} />
      </div>
    </>
  );
};

export default Statistics;
